<template>
<div id="trafico-detalle-carga">

    <v-form ref="form" id="detalle_carga_form">
        <div class="row">
            <div class="col-xs-1">
                <v-btn fab dark x-small color="green" v-on:click="addNew" title="Agregar" v-tippy>
                    <v-icon dark>add</v-icon>
                </v-btn>
            </div>
            <div class="col-xs-10"></div>
        </div>
        <div v-for="(detalle, index) in detalles" v-bind:key="index" @keyup.enter="nextTab">
            <v-row  style="flex-wrap: nowrap;">
                <v-col cols="3" class="flex-grow-0 flex-shrink-0">
                    <v-text-field :name="'nombre['+index+']'" label="Num. Bultos" type="text" autocomplete="off" class="center-input" :rules="[validaCantidadEntera]" v-model="detalle.num_bultos"></v-text-field>

                </v-col>
                <v-col cols="3" class="flex-grow-1 flex-shrink-0">
                    <v-text-field :name="'nombre['+index+']'" label="Tipo de Bultos" type="text" autocomplete="off" v-model="detalle.tipo_bultos" :rules="[rules.required]"></v-text-field>

                </v-col>
                <v-col cols="3" class="flex-grow-0 flex-shrink-1">

                    <v-text-field :name="'nombre['+index+']'" label="Peso Neto (Kgs)" type="text" class="center-input" autocomplete="off" :rules="[validaCantidad]" v-model="detalle.peso_neto"></v-text-field>

                </v-col>
                <v-col cols="3" class="flex-grow-0 flex-shrink-1">
                    <v-text-field :name="'nombre['+index+']'" label="Peso Bruto (Kgs)" class="center-input" type="text" autocomplete="off" :rules="[validaCantidad]" v-model="detalle.peso_bruto"></v-text-field>

                </v-col>
            </v-row>
            <v-row  style="flex-wrap: nowrap;">
                <v-col cols="3" class="flex-grow-0 flex-shrink-0">
                      <v-text-field :name="'nombre['+index+']'" label="Vol. (CBM)" type="text" class="center-input" autocomplete="off" :rules="[validaCantidad]" v-model="detalle.vol_cbm"></v-text-field>
               
                </v-col>
                <v-col cols="3" class="flex-grow-1 flex-shrink-0">
                    <v-text-field :name="'nombre['+index+']'" label="Número de Contenedor" type="text" class="center-input" autocomplete="off" v-model="detalle.numero_contenedor" :rules="[rules.required]"></v-text-field>
               
                </v-col>
                <v-col cols="5" class="flex-grow-0 flex-shrink-1">

                       <v-autocomplete v-model="detalle.tipo" :items="tipos" :hide-no-data="true" item-text="descripcion" item-value="clave" label="Selecciona un Tipo" :rules="[rules.required]"></v-autocomplete>
            
                </v-col>
                <v-col cols="1" class="flex-grow-0 flex-shrink-1">
                 <v-btn fab dark x-small color="red" v-on:click="remove(index)" title="Eliminar" v-tippy>
                        <v-icon dark>remove</v-icon>
                    </v-btn>
                </v-col>
            </v-row>
            
            <hr>
        </div>

    </v-form>

    <p />
    <p />
    <p />

</div>
</template>

<script>
import axios from 'axios';
import Vue from "vue";

export default {
    components: {},

    data: () => ({
        fab: false,
        formUpdated: false,
        detalle: [{
            num_bultos: 0,
            tipo_bultos: "",
            peso_neto: 0.0,
            peso_bruto: 0.0,
            vol_cbm: 0.0,
            numero_contenedor: "",
            tipo: ""
        }],
        detalles: [],
        tipos: [],
        model: [],
        URL: '',
        show_loading: false,
        loading: false,
        rules: {
            required: v => !!v || "Este campo es requerido",
            number: value => {
                const pattern = /^[\d]*\.?[\d]*$/;
                return pattern.test(value) || "Campo numérico";
            },
            entero: value => {
                const pattern = /^[\d]*$/;
                return pattern.test(value) || "Campo numérico entero";
            }
        },

    }),

    methods: {
        nextTab() {
            this.$emit('nextTab', 2);
        },
        addNew: function () {
            this.detalles.push(Vue.util.extend({}, this.model));
        },
        remove: function (index) {
            Vue.delete(this.detalles, index);
        },
        validaCantidad: function(v){            
            if (v===0) {
                return true;
            } 
            if (!!v) { 
                const pattern = /^[\d]*\.?[\d]*$/;
                return pattern.test(v) || "Campo numérico";                                    
            } else {
                return "Este campo es requerido";
            }
            return true;
        },
        validaCantidadEntera: function(v){            
            if (v===0) {
                return true;
            } 
            if (!!v) { 
                const pattern = /^[\d]*$/;
                return pattern.test(v) || "Campo numérico entero";                                    
            } else {
                return "Este campo es requerido";
            }
            return true;
        },

        guardar(resolve) {
            var referencia = this.$local_storage.get('referencia');
            var rfc = this.$local_storage.get('rfc');
            if (referencia != null && referencia.trim() != '') {
                const datos = {
                    rfc: rfc,
                    referencia: referencia,
                    detalles_carga: this.detalles,
                };

                if (!this.$refs.form.validate()) {
                    this.$swal({
                        type: "info",
                        title: "Cuidado!",
                        text: 'Datos incompletos en el formulario. Favor de verificar.'
                    });
                    resolve(false);
                } else if (this.formUpdated == true) {
                    this.$root.$dialogLoader.show('Espere un momento por favor..');

                    axios({
                            method: "put",
                            url: this.URL + "actualizar/",
                            data: datos
                        })
                        .then((res) => {
                            this.$swal({
                                type: "success",
                                title: "¡Operación Exitosa!",
                                text: "El Detalle de Carga se guardó correctamente",
                            });
                            this.$root.$dialogLoader.hide();
                            this.formUpdated = false;
                            resolve(true);
                        })
                        .catch((error) => {
                            this.$swal({
                                position: "center",
                                type: "error",
                                title: "¡Operación no Permitida!",
                                text: 'Error al guardar los datos!'
                                //showConfirmButton: false,
                            });
                            console.log(error);
                            this.$root.$dialogLoader.hide();
                            resolve(false);
                        });

                } else {
                    resolve(true);
                }
            } else {
                this.$swal({
                    type: "error",
                    title: "¡Operación no Permitida!",
                    text: 'Primero debe guardar datos generales del tráfico'
                });
                resolve(false);
            }
        },

        cargar: function () {
            var referencia = this.$local_storage.get('referencia');
            var rfc = this.$local_storage.get('rfc');
            if (referencia != null && referencia.trim() != '') {
                var datos = {
                    rfc: rfc,
                    referencia: referencia,
                };
                this.$root.$dialogLoader.show('Espere un momento por favor..');
                axios.post(this.URL + 'obtener/', datos)
                    .then((res) => {

                        if (typeof res.data !== 'undefined') {
                            this.detalles = res.data.detalles_carga;
                            if (this.detalles.length == 0)
                                this.addNew();
                        }
                    })
                    .catch((err) => {
                        this.$swal({
                            position: "center",
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "Error al obtener los registros"
                            //showConfirmButton: false,
                        });
                        console.log(err.response);
                    })
                    .then(() => {
                        this.$root.$dialogLoader.hide();
                        this.formUpdated = false;
                    });
            }

        },

        cargarTipos: function () {

            var datos = {
                tabla: 3, //Tipos de contenedores
            };
            axios.post(this.$hostname + 'apendices/lista/', datos)
                .then((res) => {
                    if (typeof res.data !== 'undefined') {
                        this.tipos = res.data;
                    }
                })
                .catch((err) => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Error al obtener los tipos de contenedores"
                    });
                    console.log(err.response);
                });
        },
        formChanged: function (newV, oldV) {
            this.formUpdated = true;
        }

    }, //methods
    created: function () {
        this.URL = this.$hostname + 'traficos/';
        this.$root.$dialogLoader.show('Espere un momento por favor..');
        this.cargar();
        this.cargarTipos();
        this.formUpdated = false;
        this.$watch('detalles', this.formChanged, {
            deep: true
        });
    },
    beforeDestroy: function () {
        this.detalles = [];
    },
}
</script>
